import React from 'react';
import './Hero.css';

const Hero = ({ onGetStarted }) => {
  return (
    <>
      <section className="hero" id="home">
        <div className="container">
          <div className="hero-content">
            <div className="trust-badge-hero">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z" stroke="#10b981" strokeWidth="2" fill="rgba(16, 185, 129, 0.1)"/>
                <path d="M9 12l2 2 4-4" stroke="#10b981" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Trusted by 10,000+ Users
            </div>
            <h1>
              Buy Flash USDT<br />
              <span className="highlight">Instantly & Securely</span>
            </h1>
            <p>
              Flashseller.in is your trusted platform for instant Flash USDT transactions. 
              Fast, secure, and reliable service with 24/7 support.
            </p>
            <div className="hero-features">
              <div className="hero-feature-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="#00d4ff"/>
                </svg>
                <span>Instant Delivery</span>
              </div>
              <div className="hero-feature-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="5" y="11" width="14" height="10" rx="2" stroke="#00d4ff" strokeWidth="2"/>
                  <path d="M8 11V7a4 4 0 118 0v4" stroke="#00d4ff" strokeWidth="2"/>
                </svg>
                <span>100% Secure</span>
              </div>
              <div className="hero-feature-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#00d4ff" strokeWidth="2"/>
                  <path d="M12 6v6l4 2" stroke="#00d4ff" strokeWidth="2"/>
                </svg>
                <span>24/7 Support</span>
              </div>
            </div>
            <button className="cta-button" onClick={onGetStarted}>
              <span>Start Buying Now</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
          <div className="hero-visual">
            <div className="hero-logo-container">
              <img src="/bigusdtlogo.jpg" alt="Flash USDT" className="hero-logo" />
              <div className="hero-glow"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="brands-section">
        <p className="brands-title">• AS SEEN ON MAJOR EXCHANGES •</p>
        <div className="brands-slider">
          <div className="brands-track">
            <div className="brand-card">
              <img src="/brand_img_Binance.png" alt="Binance" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_coinbase.png" alt="Coinbase" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_Huobi.png" alt="Huobi" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_Metamask.png" alt="Metamask" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_okx.png" alt="OKX" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_upbit.png" alt="Upbit" className="brand-logo" />
            </div>
            {/* Duplicate for seamless loop */}
            <div className="brand-card">
              <img src="/brand_img_Binance.png" alt="Binance" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_coinbase.png" alt="Coinbase" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_Huobi.png" alt="Huobi" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_Metamask.png" alt="Metamask" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_okx.png" alt="OKX" className="brand-logo" />
            </div>
            <div className="brand-card">
              <img src="/brand_img_upbit.png" alt="Upbit" className="brand-logo" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
